import theme from 'config/theme';

export const CREDIT_CHECK_STAGE_ENUMS = {
  Backlog: 1,
  SalesPending: 2,
  CounterOffer: 3,
  Approved: 4,
  Rejected: 5,
  CreditPending: 6,
};

export const CREDIT_CHECK_TABLE_STAGES = {
  Backlog: {
    label: 'Backlog',
    styles: {
      backgroundColor: theme.palette.grays.gray200,
      color: theme.palette.grays.gray900,
    },
  },
  SalesPending: {
    label: 'Sales Pending',
    styles: {
      backgroundColor: theme.palette.blues.primaryBlue700,
      color: theme.palette.white.paper,
    },
  },
  CreditPending: {
    label: 'Credit Pending',
    styles: {
      backgroundColor: theme.palette.onlyTextTeal.main,
      color: theme.palette.white.paper,
    },
  },
  CounterOffer: {
    label: 'Counter Offer',
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  Approved: {
    label: 'Approved',
    styles: {
      backgroundColor: theme.palette.mints.mint200,
      color: theme.palette.mints.mint900,
    },
  },
  Rejected: {
    label: 'Rejected',
    styles: {
      backgroundColor: theme.palette.reds.red200,
      color: theme.palette.reds.red900,
    },
  },
};

export const CREDIT_CHECK_TABLE_STAGES_ORDER = [
  'Backlog',
  'SalesPending',
  'CreditPending',
  'CounterOffer',
  'Approved',
  'Rejected',
];

export const INITIAL_CREDIT_CHECK_GRID_COLUMNS = [
  { value: true, label: 'Booking ID', key: 'bookingId' },
  { value: true, label: 'Customer Name', key: 'fullName' },
  { value: true, label: 'Vehicle', key: 'vehicle' },
  { value: true, label: 'Date', key: 'date' },
  { value: true, label: 'Vehicle Holding Company', key: 'vehicleTenant' },
  { value: true, label: 'Customer Type', key: 'customerType' },
  {
    value: true,
    label: 'User ID',
    key: 'userId',
  },
  { value: true, label: 'Booking Assignee', key: 'assignee' },
  { value: true, label: 'Contract Period', key: 'contractPeriod' },
  { value: true, label: 'Account Type', key: 'bookingAccountType' },
  { value: true, label: 'Initial Payment', key: 'initialPayment' },
  { value: true, label: 'Origin', key: 'origin' },
  { value: true, label: 'Phone Number', key: 'phoneNumber' },
  { value: true, label: 'SKU ID', key: 'skuId' },
  { value: true, label: 'Labels', key: 'labels' },
  { value: true, label: 'Stage', key: 'stage' },
];
